import { guestCall } from '@gem/call/storage/adapters';
import {
  deviceId,
  videoPlayerConfig,
  feedback,
  refreshToken,
  connectionToken,
  reactionsPack,
  language,
} from '@gem/modules/storage';

import * as authorizationConfig from './adapters/authorizationConfig';
import * as calendar from './adapters/calendar';
import * as chatBackgroundGlobal from './adapters/chatBackground/chatBackgroundGlobal';
import * as chatBackgroundsByEntity from './adapters/chatBackground/chatBackgroundsByEntity';
import * as chatBackgroundsCustom from './adapters/chatBackground/chatBackgroundsCustom';
import * as countriesPhoneCodes from './adapters/countriesPhoneCodes/countriesPhoneCodes';
import * as discoverDestinations from './adapters/discoverDestinations';
import * as emojiStickersTab from './adapters/emojiStickersPanel/emojiStickersTab';
import * as installedStickerPacks from './adapters/emojiStickersPanel/installedStickerPacks';
import * as publicStickerPacks from './adapters/emojiStickersPanel/publicStickerPacks';
import * as selectedEmojiCategory from './adapters/emojiStickersPanel/selectedEmojiCategory';
import * as selectedStickerPack from './adapters/emojiStickersPanel/selectedStickerPack';
import * as oauthReturnUrl from './adapters/oauthReturnUrl';
import * as onboarding from './adapters/onboarding';
import * as preferredDiscoverDestinationKey from './adapters/preferredDiscoverDestinationKey';
import * as pushNotifications from './adapters/pushNotifications';
import * as rewards from './adapters/rewards';
import * as secretChatOnboarding from './adapters/secretChatOnboarding';
import * as tenantRouting from './adapters/tenantRouting';
import * as theme from './adapters/theme';

export const storage = {
  chatBackgroundGlobal,
  chatBackgroundsByEntity,
  chatBackgroundsCustom,
  connectionToken,
  countriesPhoneCodes,
  deviceId,
  emojiStickersTab,
  feedback,
  guestCall,
  installedStickerPacks,
  calendar,
  oauthReturnUrl,
  onboarding,
  publicStickerPacks,
  reactionsPack,
  refreshToken,
  rewards,
  selectedEmojiCategory,
  selectedStickerPack,
  tenantRouting,
  theme,
  videoPlayerConfig,
  pushNotifications,
  secretChatOnboarding,
  authorizationConfig,
  discoverDestinations,
  preferredDiscoverDestinationKey,
  language,
};
